'use strict';
/*
* Novicell master
* Use this file to call functions in other files, on document ready, window.resize etc.
*/

var novicell = novicell || {};
var project = project || {};

// Document ready
document.addEventListener('DOMContentLoaded', function(){

    setTimeout(function() {
        svg4everybody(); // Fix SVG spritemap in IE/Edge
    });

    novicell.navigation.init();
    novicell.lazyLoader.init();
    novicell.loadMore.init();
    novicell.oembedOverlay.init();
    novicell.anchorScroll.init();
    novicell.sliders.init();
    novicell.openChatAutomatically.init();

	var site_header 	= document.getElementById('js-site-header'),
		header_height 	= window.innerWidth > 767 ? 80 : 48,
		sections 		= document.querySelectorAll('.section');

  window.onscroll = function () {
    let scroll_top = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);

    for (var i = 0; i < sections.length; i++) {
      let section 			= sections[i],
        section_offsetTop 	= section.offsetTop - header_height;

      if ( section_offsetTop <= scroll_top && section_offsetTop + section.offsetHeight > scroll_top ) {
        let section_attr		= section.hasAttribute('header-color'),
          color_class_add 	= section_attr ? 'site-header--color' : 'site-header--white',
          color_class_remove 	= section_attr ? 'site-header--white' : 'site-header--color';

        site_header.classList.add(color_class_add);
        site_header.classList.remove(color_class_remove);
      }
    };

    novicell.siteHeader.checkScroll();
  };


    var mce_chat_toggles = document.querySelectorAll('.js-mce-chat-toggle');

    if ( mce_chat_toggles ) {
    	mce_chat_toggles.forEach(btn => {
    		var text 	= btn.innerHTML,
    			classes = btn.getAttribute('class');

    		btn.removeAttribute('class');
    		btn.innerHTML = '<button class="'+classes+'" type="button" onclick="toggleChat();">'+text+'</button>';
    	});
    }
});


